import { render, staticRenderFns } from "./FormResponseType3.vue?vue&type=template&id=1d827bef&scoped=true&"
import script from "./FormResponseType3.vue?vue&type=script&lang=js&"
export * from "./FormResponseType3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d827bef",
  null
  
)

export default component.exports